import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchPolicyViewModel, fetchPolicyViewModelError, fetchPolicyViewModelSuccess } from './actions';

import { DetailsPolicyActionTypes } from './types';
import { getPolicyViewModel } from '../../utils/api/casesApi';
import { SagaIterator } from 'redux-saga';

function* handleFetchPolicyViewModel(action: ReturnType<typeof fetchPolicyViewModel>): SagaIterator {
  try {
    const res = yield call(getPolicyViewModel, action.payload.caseCode);

    if (!res.data) {
      yield put(fetchPolicyViewModelError(JSON.stringify(res.response)));
    } else {
      yield put(fetchPolicyViewModelSuccess(res.data));
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchPolicyViewModelError(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(fetchPolicyViewModelError('An unknown error occured.'));
    }
  }
}

function* watchDetailsPolicy() {
  yield takeEvery(DetailsPolicyActionTypes.FETCH_POLICY_VIEW_MODEL, handleFetchPolicyViewModel);
}

function* detailsPolicySaga() {
  yield all([fork(watchDetailsPolicy)]);
}

export default detailsPolicySaga;
